const actions = {
    /* TAG GROUP */
    CREATE_TAG_GROUP_REQUEST: 'CREATE_TAG_GROUP_REQUEST',
    CREATE_TAG_GROUP_SUCCESS: 'CREATE_TAG_GROUP_SUCCESS',
    CREATE_TAG_GROUP_ERROR: 'CREATE_TAG_GROUP_ERROR',
    READ_TAG_GROUPS_REQUEST: 'READ_TAG_GROUPS_REQUEST',
    READ_TAG_GROUPS_SUCCESS: 'READ_TAG_GROUPS_SUCCESS',
    READ_TAG_GROUPS_ERROR: 'READ_TAG_GROUPS_ERROR',
    READ_TAG_GROUP_REQUEST: 'READ_TAG_GROUP_REQUEST',
    READ_TAG_GROUP_SUCCESS: 'READ_TAG_GROUP_SUCCESS',
    READ_TAG_GROUP_ERROR: 'READ_TAG_GROUP_ERROR',
    UPDATE_TAG_GROUP_REQUEST: 'UPDATE_TAG_GROUP_REQUEST',
    UPDATE_TAG_GROUP_SUCCESS: 'UPDATE_TAG_GROUP_SUCCESS',
    UPDATE_TAG_GROUP_ERROR: 'UPDATE_TAG_GROUP_ERROR',
    DELETE_TAG_GROUP_REQUEST: 'DELETE_TAG_GROUP_REQUEST',
    DELETE_TAG_GROUP_SUCCESS: 'DELETE_TAG_GROUP_SUCCESS',
    DELETE_TAG_GROUP_ERROR: 'DELETE_TAG_GROUP_ERROR',
    ACTIVATE_TAG_GROUP_REQUEST: 'ACTIVATE_TAG_GROUP_REQUEST',
    ACTIVATE_TAG_GROUP_SUCCESS: 'ACTIVATE_TAG_GROUP_SUCCESS',
    ACTIVATE_TAG_GROUP_ERROR: 'ACTIVATE_TAG_GROUP_ERROR',
    /* TAG */
    CREATE_TAG_REQUEST: 'CREATE_TAG_REQUEST',
    CREATE_TAG_SUCCESS: 'CREATE_TAG_SUCCESS',
    CREATE_TAG_ERROR: 'CREATE_TAG_ERROR',
    READ_TAG_REQUEST: 'READ_TAG_REQUEST',
    READ_TAG_SUCCESS: 'READ_TAG_SUCCESS',
    READ_TAG_ERROR: 'READ_TAG_ERROR',
    UPDATE_TAG_REQUEST: 'UPDATE_TAG_REQUEST',
    UPDATE_TAG_SUCCESS: 'UPDATE_TAG_SUCCESS',
    UPDATE_TAG_ERROR: 'UPDATE_TAG_ERROR',
    DELETE_TAG_REQUEST: 'DELETE_TAG_REQUEST',
    DELETE_TAG_SUCCESS: 'DELETE_TAG_SUCCESS',
    DELETE_TAG_ERROR: 'DELETE_TAG_ERROR',
    ACTIVATE_TAG_REQUEST: 'ACTIVATE_TAG_REQUEST',
    ACTIVATE_TAG_SUCCESS: 'ACTIVATE_TAG_SUCCESS',
    ACTIVATE_TAG_ERROR: 'ACTIVATE_TAG_ERROR',
    TAG_RESET_STATE: 'TAG_RESET_STATE',

    createTagGroup: request => ({
        type: actions.CREATE_TAG_GROUP_REQUEST,
        request,
    }),
    readTagGroups: request => ({
        type: actions.READ_TAG_GROUPS_REQUEST,
        request,
    }),
    readTagGroup: id => ({
        type: actions.READ_TAG_GROUP_REQUEST,
        id,
    }),
    updateTagGroup: (id, request) => ({
        type: actions.UPDATE_TAG_GROUP_REQUEST,
        id,
        request,
    }),
    deleteTagGroup: id => ({
        type: actions.DELETE_TAG_GROUP_REQUEST,
        id,
    }),
    activateTagGroup: id => ({
        type: actions.ACTIVATE_TAG_GROUP_REQUEST,
        id,
    }),
    createTag: request => ({
        type: actions.CREATE_TAG_REQUEST,
        request,
    }),
    readTag: id => ({
        type: actions.READ_TAG_REQUEST,
        id,
    }),
    updateTag: (id, request) => ({
        type: actions.UPDATE_TAG_REQUEST,
        id,
        request,
    }),
    deleteTag: id => ({
        type: actions.DELETE_TAG_REQUEST,
        id,
    }),
    activateTag: id => ({
        type: actions.ACTIVATE_TAG_REQUEST,
        id,
    }),
    resetState: () => ({
        type: actions.TAG_RESET_STATE,
    }),
};
export default actions;
